import { createSelector } from "reselect";
import { ListFieldsKeys } from "src/api/config";
import { JustAddedItem } from "src/modules/modules.type";
import { RootState } from "src/store/rootReducer";

const getJustAddedItem = (state: RootState, listName: ListFieldsKeys): JustAddedItem => {
    return state.spitems.justAdded[listName] || 0;
};

export const selectJustAddedItem = createSelector([getJustAddedItem], (id) => {
    return id;
});
